let pendingPassportCode: string | null = null;

const PASSPORT_PATH_PREFIX = '/vehicle-passport/';
const CODE_PATTERN = /^[A-Z0-9]{7}$/;

export const sanitizeVehiclePassportFragment = (): void => {
  if (!window.location.pathname.startsWith(PASSPORT_PATH_PREFIX)) return;
  const rawFragment = window.location.hash.slice(1);
  const normalized = rawFragment.trim().toUpperCase();
  pendingPassportCode = CODE_PATTERN.test(normalized) ? normalized : null;
  if (window.location.hash) {
    window.history.replaceState(
      window.history.state,
      document.title,
      `${window.location.pathname}${window.location.search}`,
    );
  }
};

export const consumeVehiclePassportCode = (): string | null => {
  const code = pendingPassportCode;
  pendingPassportCode = null;
  return code;
};

export const normalizeVehiclePassportCode = (value: string): string | null => {
  const normalized = value.trim().toUpperCase();
  return CODE_PATTERN.test(normalized) ? normalized : null;
};
